export default __webpack_public_path__ + "static/media/ktp-example.41a76820.png";